export const SCHOOL_NAV_ITEMS = [
  {
    to: "/school-admin/dashboard",
    icon: "fas fa-home",
    label: "Dashboard",
    roles: [
      "school-admin",
      "assistant",
      "accounts",
      "principal",
      "viewer",
      "head-master",
    ],
  },
  {
    to: "/school-admin/students",
    icon: "fa-solid fa-graduation-cap",
    label: "Students",
    roles: ["school-admin", "assistant", "principal", "viewer", "head-master"],
  },
  {
    to: "/school-admin/teachers",
    icon: "fa-solid fa-user-tie",
    label: "Teachers",
    roles: ["school-admin", "principal", "viewer", "head-master"],
  },
  {
    to: "/school-admin/classroom",
    icon: "fa-solid fa-chalkboard",
    label: "Classroom",
    roles: ["school-admin", "principal", "viewer", "head-master"],
  },
  {
    to: "/school-admin/lesson",
    icon: "bi bi-book",
    label: "Lesson",
    roles: [
      "school-admin",
      "assistant",
      "accounts",
      "principal",
      "head-master",
      "viewer",
    ],
  },
  {
    to: "/school-admin/school/report",
    icon: "fa-solid fa-chart-bar",
    label: "Reports",
    roles: ["school-admin", "principal", "viewer", "head-master"],
  },
  {
    to: "/school-admin/import-history",
    icon: "fa-solid fa-database",
    label: "Import History",
    roles: ["school-admin", "principal", "head-master"],
  },
  {
    to: "/school-admin/quest",
    icon: "bi bi-trophy",
    label: "Quests",
    roles: [
      "school-admin",
      "assistant",
      "accounts",
      "principal",
      "head-master",
      "viewer",
    ],
  },
  {
    to: "/school-admin/notifications",
    icon: "fa-solid fa-bell",
    label: "Notifications",
    roles: [
      "school-admin",
      "assistant",
      "accounts",
      "principal",
      "head-master",
    ],
  },
  {
    to: "/school-admin/settings",
    icon: "fa-solid fa-gear",
    label: "Settings",
    roles: ["school-admin", "principal", "accounts", "head-master"],
  },
];
